<template>
    <div class="layer-controls" :style="{'z-index': 1000, position: 'absolute'}">
        <div class="control" @click="changeLayerIndex(1)">
            <icon :name="'ic_arrow_drop_up_white_24px'"></icon>
        </div>
        <div class="control" @click="changeLayerIndex(0)">
            <icon :name="'ic_layers_white_24px'"></icon>
        </div>
        <div class="control" @click="changeLayerIndex(-1)">
            <icon :name="'ic_arrow_drop_down_white_24px'"></icon>
        </div>
        <div class="divider"></div>
        <div class="control" @click="removeLayer">
            <icon :name="'ic_layers_clear_white_24px'"></icon>
        </div>
        
    </div>
</template>

<script type="text/babel">
import Icon from '../../../../Shared/Icons/Icon.vue';
export default {
    name: 'LayerControls',
    props: {
        layerId: {
            type: String
        }
    },
    components: {
        Icon
    },
    methods: {
        changeLayerIndex (direction) {
            this.$emit('changeLayerIndex', {
                layerId: this.layerId,
                direction
            });
        },
        removeLayer () {
            this.$emit('removeLayer', this.layerId);
        }
    }
};

</script>

